import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';
import { TASK_STATUSES } from '../../data/mockData';
import './Charts.css';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const CORPORATE_COLORS = [
  'rgba(71, 85, 105, 0.85)',
  'rgba(59, 130, 246, 0.85)',
  'rgba(100, 116, 139, 0.85)',
  'rgba(148, 163, 184, 0.85)',
  'rgba(34, 197, 94, 0.85)',
  'rgba(239, 68, 68, 0.85)',
  'rgba(245, 158, 11, 0.85)'
];

const StatusChart = ({ tasks }) => {
  const statusCount = {};
  TASK_STATUSES.forEach(s => { statusCount[s] = 0; });
  tasks.forEach(task => {
    const s = task.currentStatus || task.status;
    if (statusCount[s] !== undefined) statusCount[s]++;
  });

  const labels = TASK_STATUSES;
  const data = labels.map(s => statusCount[s]);
  const total = data.reduce((a, b) => a + b, 0);

  if (total === 0) {
    return (
      <div className="chart-container">
        <div className="chart-empty-state"><p>No tasks to display</p></div>
      </div>
    );
  }

  const chartData = {
    labels,
    datasets: [{
      label: 'Tasks by status',
      data,
      backgroundColor: labels.map((_, i) => CORPORATE_COLORS[i % CORPORATE_COLORS.length]),
      borderColor: 'rgba(255,255,255,0.9)',
      borderWidth: 1,
      borderRadius: 4
    }]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const pct = total ? ((ctx.parsed.x / total) * 100).toFixed(1) : 0;
            return `${ctx.parsed.x} (${pct}%)`;
          }
        }
      }
    },
    scales: {
      x: { beginAtZero: true, grid: { color: 'rgba(0,0,0,0.06)' } },
      y: { grid: { display: false } }
    }
  };

  return (
    <div className="chart-container">
      <h4 className="chart-title">Tasks by status</h4>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default StatusChart;
